import { render, staticRenderFns } from "./Unlock.vue?vue&type=template&id=4061265a&scoped=true&"
import script from "./Unlock.vue?vue&type=script&lang=ts&"
export * from "./Unlock.vue?vue&type=script&lang=ts&"
import style0 from "./Unlock.vue?vue&type=style&index=0&id=4061265a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061265a",
  null
  
)

export default component.exports